module.exports = require("jquery");